import { render, staticRenderFns } from "./MyKPI.vue?vue&type=template&id=06ec671f&scoped=true"
import script from "./MyKPI.vue?vue&type=script&lang=js"
export * from "./MyKPI.vue?vue&type=script&lang=js"
import style0 from "./MyKPI.vue?vue&type=style&index=0&id=06ec671f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ec671f",
  null
  
)

export default component.exports